/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';
module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_filter_by_distance'),
    viewClass: require('../modules/views/accommodation_filter_by_distance'),

    init: function() {
        this.options = Odigeo.parseOptions(this.options);
        return this;
    },

    refreshSlider: function() {
        this.view.slider.updateHandlers();
    },

    renderTitleWithDestination: function(destination) {
        this.view.renderTitleWithDestination(destination);
    },
});
